<template>
  <div class="container mt-4">
    <h2>Gestionar Roles y Permisos</h2>

    <!-- Gestión de Roles -->
    <div class="row mt-4">
      <div class="col-md-6">
        <div class="card shadow-sm">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Roles</h5>
            <button class="btn btn-sm btn-link" @click="toggleSection('roles')">
              <font-awesome-icon :icon="collapsedSections.roles ? 'fa-window-maximize' : 'fa-window-minimize'" />
            </button>
          </div>
          <div v-if="!collapsedSections.roles" class="card-body">
            <gestionar-roles
              :roles="rolesFiltrados"
              @crear-role="crearRole"
              @eliminar-role="eliminarRole"
              @search-role="searchRole"
            />
          </div>
        </div>
      </div>

      <!-- Gestión de Permisos -->
      <div class="col-md-6">
        <div class="card shadow-sm">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Permisos</h5>
            <button class="btn btn-sm btn-link" @click="toggleSection('permisos')">
              <font-awesome-icon :icon="collapsedSections.permisos ? 'fa-window-maximize' : 'fa-window-minimize'" />
            </button>
          </div>
          <div v-if="!collapsedSections.permisos" class="card-body">
            <gestionar-permisos
              :permisos="permisosFiltrados"
              @crear-permiso="crearPermiso"
              @eliminar-permiso="eliminarPermiso"
              @search-permiso="searchPermiso"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Vinculación de Roles y Permisos -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="card shadow-sm">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Vincular Permisos a Roles</h5>
            <button class="btn btn-sm btn-link" @click="toggleSection('vinculacion')">
              <font-awesome-icon :icon="collapsedSections.vinculacion ? 'fa-window-maximize' : 'fa-window-minimize'" />
            </button>
          </div>
          <div v-if="!collapsedSections.vinculacion" class="card-body">
            <vincular-roles-permisos
              :roles="roles"
              :permisos="permisos"
              @vincular-permiso="vincularPermiso"
              @desvincular-permiso="desvincularPermiso"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import GestionarRoles from "./GestionarRoles.vue";
import GestionarPermisos from "./GestionarPermisos.vue";
import VincularRolesPermisos from "./VincularRolesPermisos.vue";

export default {
  components: {
    GestionarRoles,
    GestionarPermisos,
    VincularRolesPermisos,
  },
  data() {
    return {
      roles: [],
      permisos: [],
      searchTermRoles: "",
      searchTermPermisos: "",
      collapsedSections: {
        roles: true,
        permisos: true,
        vinculacion: true,
      },
    };
  },
  computed: {
    rolesFiltrados() {
      
      if(this.searchTermRoles === "") return this.roles;  
      return this.roles.filter((role) =>
        role.nombre.toLowerCase().includes(this.searchTermRoles.toLowerCase())
      );
    },
    permisosFiltrados() {
      if(this.searchTermPermisos === "") return this.permisos;

      return this.permisos.filter((permiso) =>
        permiso.nombre.toLowerCase().includes(this.searchTermPermisos.toLowerCase())
      );
    },
  },
  methods: {
    toggleSection(section) {
      this.collapsedSections[section] = !this.collapsedSections[section];
    },
    async cargarDatos() {
      this.cargarRoles();
      this.cargarPermisos();
    },
    async cargarRoles() {
      try {
        const response = await axios.get("/api/roles");
        this.roles = response.data;
      } catch (error) {
        console.error("Error al cargar roles:", error);
      }
    },
    async cargarPermisos() {
      try {
        const response = await axios.get("/api/roles/permisos");
        this.permisos = response.data;
      } catch (error) {
        console.error("Error al cargar permisos:", error);
      }
    },
    async crearRole(nombre) {
      try {
        const response = await axios.post("/api/roles", { nombre });
        const newRole = { ...response.data, usr_role_permisos: [] }; // Inicializar usr_role_permisos vacío
        this.roles.push(newRole);
      
      } catch (error) {
        console.error("Error al crear rol:", error);
      }
    },
    async eliminarRole(role_id) {
      try {
        await axios.delete(`/api/roles/${role_id}`);
        this.roles = this.roles.filter((r) => r.id !== role_id);
      } catch (error) {
        console.error("Error al eliminar rol:", error);
      }
    },
    async crearPermiso(nombre) {
      try {
        const response = await axios.post("/api/roles/permisos", { nombre });
        this.permisos.push(response.data);
      } catch (error) {
        console.error("Error al crear permiso:", error);
      }
    },
    async eliminarPermiso(permiso_id) {
      try {
        await axios.delete(`/api/roles/permisos/${permiso_id}`);
        this.permisos = this.permisos.filter((p) => p.id !== permiso_id);
      } catch (error) {
        console.error("Error al eliminar permiso:", error);
      }
    },
    searchRole(search) {
      this.searchTermRoles = search;
    },
    searchPermiso(search) {
      this.searchTermPermisos = search;
    },
    async vincularPermiso(role_id, permiso_id) {
      try {
        await axios.post(`/api/roles/${role_id}/permisos`, { permiso_id });
        this.cargarDatos();
      } catch (error) {
        console.error("Error al vincular permiso:", error);
      }
    },
    async desvincularPermiso(role_id, permiso_id) {
      try {
        await axios.delete(`/api/roles/${role_id}/permisos/${permiso_id}`);
        this.cargarDatos();
      } catch (error) {
        console.error("Error al desvincular permiso:", error);
      }
    },
  },
  mounted() {
    this.cargarDatos();
  },
};
</script>

<style scoped>
.container {
  max-width: 1000px;
}

.card {
  border-radius: 8px;
}

.card-header {
  font-weight: bold;
}

h2 {
  color: #2c3e50;
}
</style>
